import mock from '../mocks/partners';

export function usePartners() {
  const partners = mock;
  return partners;
};